import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'melitta',
} as IModuleProps;
